/* eslint-disable jsx-a11y/anchor-is-valid */
import labelKey from "../../../../localization/label.json"
import TextField from '../../../../../components/textFields/TextField';

type Props = {
  formik: any
}
const Step2 = ({ formik, }: Props) => {

  return (
    <div className='pb-5 pe-3 overflow-auto' style={{ height: "51vh" }} data-kt-stepper-element='content'>
      <div className='row w-100 h-min-content'>
        <div className='col-md-6 mb-5'>
          <TextField
            label={labelKey.domainName}
            placeholder='Enter Domain Name'
            type="text"
            {...formik.getFieldProps('domainName')}
          />
        </div>
        <div className='col-md-6 mb-5'>
          <TextField
            label={labelKey.webUrl}
            placeholder='Enter Web Url'
            type="text"
            {...formik.getFieldProps('webURL')}
          />
        </div>
        <div className='col-md-6 mb-5'>
          <TextField
            label={labelKey.apiUrl}
            placeholder='Enter Api Url'
            type="text"
            {...formik.getFieldProps('apiurl')}
          />
        </div>
        <div className='col-md-6 mb-5'>
          <TextField
            label={labelKey.microServiceURL}
            placeholder='Enter Micro Service URL'
            type="text"
            {...formik.getFieldProps('microServiceURL')}
          />
        </div>
        <div className="col-6">
          <label className='form-label fs-5 fw-bold'>{labelKey.isOrgAllowTravelBooking}</label>
          <div className="form-check form-switch">
            <input
              className="form-check-input cursor-pointer mt-3"
              type="checkbox"
              role="switch"
              id={`isOrgAllowTravelBooking`}
              {...formik.getFieldProps('isOrgAllowTravelBooking')}
              checked={formik.values.isOrgAllowTravelBooking}
            />
          </div>
        </div>
        <div className="col-6">
          <label className='form-label fs-5 fw-bold'>{labelKey.isOrgAllowedCorporateExpenses}</label>
          <div className="form-check form-switch">
            <input
              className="form-check-input cursor-pointer mt-3"
              type="checkbox"
              role="switch"
              id={`isOrgAllowedCorporateExpenses`}
              {...formik.getFieldProps('isOrgAllowedCorporateExpenses')}
              checked={formik.values.isOrgAllowedCorporateExpenses}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export { Step2 };

